import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from '../../core/shared/dto/dto-service/entity-service-registry';
import {VisitService} from './service/visit.service';
import {VsVisitComponent} from './component/object-components/vs-visit/vs-visit.component';

/**
 * Entity registry for the Visit (vs) module.
 *
 * Registration decisions per MvsCrudService skill SC6/SC7 rules:
 *
 * SERVICE-BACKED:
 *   - vs.Visit — has a service file ({@link VisitService}) because the
 *     component specialist will wire an objectComponent (crud-object component)
 *     in a follow-on wave. The service file also serves as the extension point
 *     for future geo-capture and lifecycle action methods.
 *
 * ROUTE-ONLY (no service file — pure CRUD, no dialog/action customisation needed):
 *   - vs.VisitType    — config entity managed via the config page grid
 *   - vs.VisitProtocol — sub-entity of Visit; managed inline via generic CRUD
 *
 * AP-2.7: the {@code objectComponent} entry for vs.Visit is now wired to
 * {@link VsVisitComponent}. This drives both the routable Visit object page and
 * the dialog rendering used by {@code openObjectViaDialog('vs.Visit')} for
 * create/edit. The mode is omitted so the component is used for non-create modes
 * (view/edit); create mode falls back to the generic metadata-driven VisitForm.
 *
 * @ticket TM-1000001921
 */
export const VS_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['vs.Visit',          {route: '/vs/visits', service: VisitService, objectComponent: [{component: VsVisitComponent}]}],
            ['vs.VisitType',      {route: '/vs/visitTypes'}],
            ['vs.VisitProtocol',  {route: '/vs/visitProtocols'}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
